import loadPostingExample from "@/assets/load-posting-voice-example.mp3.asset.json";

/**
 * Registry of LR Direct voice audio clips (the "hear an example" player).
 *
 * ATLAS spoken response clips live in ./atlasVoiceManifest (one module, no
 * per-file pointer imports) and are re-exported here for existing callers.
 */
export const VOICE_CLIPS = {
  loadPostingExample: {
    url: loadPostingExample.url as string,
    label: "Load posting example",
  },
} as const;

export type VoiceClipKey = keyof typeof VOICE_CLIPS;

export function getVoiceClipUrl(key: VoiceClipKey): string | null {
  return VOICE_CLIPS[key]?.url || null;
}

export {
  ATLAS_RESPONSE_CLIPS,
  getRandomAtlasResponseUrl,
  getAnyAtlasClipUrl,
} from "./atlasVoiceManifest";
export type { AtlasResponseCategory } from "./atlasVoiceManifest";
